import { ArrowUpRight } from 'lucide-react'

import { AppShell } from '@/components/px/AppShell'
import { SectionLabel } from '@/components/px/SectionLabel'
import { StatusPill } from '@/components/px/StatusPill'
import { DESIGN_DIRECTIONS } from '@/design-directions'

/** The design-round registry — how this prototype's look was decided. */
export default function DesignsPage() {
  return (
    <AppShell moduleLabel="PX · Design" breadcrumb="Design rounds › Round 1 bake-off" contextPill="ROUND 1 · CLOSED">
      <h1 className="font-serif text-2xl font-semibold">Design directions — round 1</h1>
      <p className="mt-2 max-w-3xl text-sm text-muted-foreground">
        Four directions rendered the same three screens with identical verbatim content. The panel scored the
        renders; Agon ratified the control. The static gallery below is the round&rsquo;s evidence.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {DESIGN_DIRECTIONS.map((d) => (
          <div key={d.key} className="rounded-lg border border-border bg-card p-4">
            <div className="flex items-center justify-between gap-2">
              <SectionLabel>{d.key}</SectionLabel>
              <StatusPill tone={d.badge === 'winner · ratified' ? 'done' : 'neutral'}>{d.badge}</StatusPill>
            </div>
            <div className="mt-1 font-serif text-lg font-semibold">{d.name}</div>
            <div className="mt-1 text-sm text-muted-foreground">{d.register}</div>
            <p className="mt-2 text-sm">{d.hypothesis}</p>
            <div className="mt-3 flex items-center justify-between border-t border-border pt-2 text-xs text-muted-foreground">
              <span className="v-figure tabular-nums">panel final {d.final} / 100</span>
              <a href={d.galleryPath} className="inline-flex items-center gap-0.5 font-medium text-accent-foreground hover:underline">
                open the render
                <ArrowUpRight className="h-3 w-3" aria-hidden />
              </a>
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  )
}
